module.exports = __webpack_public_path__ + "static/warning-do-example-f1fb835ab270ea0b58f4e035d9f8719e.svg";